export const TicketStatusConfig: any = {
    open: 'Open',
    in_progress: 'In Progress',
    closed: 'Closed',
    cancelled: 'Cancelled'
}

export const TicketSeverityConfig: any = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical'
}

export const TicketSeverityColorConfig: any = {
    low: 'success',
    medium: 'info',
    high: 'warning',
    critical: 'error'
}

export const UserTypeConfig: any = {
    admin: 'Admin',
    MP: 'MP'
}

export const UserTypeWisePagesConfig: any = {
    admin: ['/admin/', '/admin/dashboard/', '/admin/tickets/', '/admin/tickets/detail/', '/admin/safety-awards/', '/admin/safety-awards/detail/', '/admin/visitors/', '/admin/visitors/details/', '/admin/create-ticket/', '/admin/master/states', '/admin/master/districts/', '/admin/master/cities/', '/admin/master/taluka', '/admin/master/village', '/admin/master/municipal-corporation', '/admin/master/party-wings', '/admin/master/party-levels', '/admin/master/governance-level', '/admin/master/parliamentary-constituency', '/admin/master/legislative-constituency', '/admin/master/ministerial-directory','/admin/members/register','/admin/members','/admin/members/detail'],
    MP: ['/admin/', '/admin/dashboard/', '/admin/tickets/', '/admin/tickets/detail/', '/admin/safety-awards/', '/admin/safety-awards/detail/', '/admin/visitors/', '/admin/visitors/details/', '/admin/create-ticket/', '/admin/master/states', '/admin/master/districts/', '/admin/master/cities/', '/admin/master/taluka', '/admin/master/village', '/admin/master/municipal-corporation', '/admin/master/party-wings', '/admin/master/party-levels', '/admin/master/governance-level', '/admin/master/parliamentary-constituency', '/admin/master/legislative-constituency','/admin/master/ministerial-directory','/admin/members/register','/admin/members','/admin/members/detail']
}

export const S3_BaseUrl = 'https://eks.ekanshconcepts.com/'